type Props = {
  search: string
  setSearch: (s: string) => void
  categories?: string[]
  selectedCategory?: string | null
  setSelectedCategory?: (c: string | null) => void
}

export default function FilterBar({ search, setSearch, categories = [], selectedCategory, setSelectedCategory }: Props) {
  return (
    <div className="filter-bar">
      <div style={{ position: 'relative', width: '100%' }}>
        <input
          aria-label="Search sets"
          placeholder="Search by name, keyword, or category"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ paddingRight: search ? '2.5rem' : '0.9rem' }}
        />
        {search && (
          <button
            onClick={() => setSearch('')}
            aria-label="Clear search"
            style={{
              position: 'absolute',
              right: '0.5rem',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '0.25rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#64748b',
              fontSize: '1.2rem',
              lineHeight: 1
            }}
          >
            ×
          </button>
        )}
      </div>
      {categories.length > 0 && (
        <div className="category-chips">
          <button className={!selectedCategory ? 'active' : ''} onClick={() => setSelectedCategory?.(null)}>All</button>
          {categories.map((c) => (
            <button key={c} className={selectedCategory === c ? 'active' : ''} onClick={() => setSelectedCategory?.(selectedCategory === c ? null : c)}>{c}</button>
          ))}
        </div>
      )}
    </div>
  )
}
